import React from "react";
import PropTypes from "prop-types";
import { MenuItem, ListItemIcon, ListItemText } from "@material-ui/core";

MenuButton.propTypes = {
  icon: PropTypes.node,
  label: PropTypes.string.isRequired,
};

function MenuButton({ icon, label, ...props }) {
  return (
    <MenuItem {...props}>
      {icon && <ListItemIcon>{icon}</ListItemIcon>}
      <ListItemText>{label}</ListItemText>
    </MenuItem>
  );
}

export default MenuButton;
